var Curriculog = Curriculog || {};

Curriculog.ProposalEntityDropdownItemView = (function ($, _, Backbone, ProposalEntityDropdownItemView) {

	ProposalEntityDropdownItemView = Curriculog.HierarchyDropdownItemView.extend({
		template: 'ProposalForm/Form/proposalEntityDropdownItem.html'
	});

	return ProposalEntityDropdownItemView;

})($, _, Backbone, Curriculog.ProposalEntityDropdownItemView || {});
